import React, { useEffect, useState } from "react";
import { BsGithub, BsFacebook, BsLinkedin } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

function Contact() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [contactAnimation, contactAnimationInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariantscontactAnimation = {
    hidden:
      windowWidth > 500
        ? {
            opacity: 0,
            x: -20,
          }
        : {
            opacity: 0,
          },
    visible:
      windowWidth > 500
        ? {
            opacity: 1,
            x: 0,
            transition: {
              duration: 1,
              ease: "easeInOut",
            },
          }
        : {
            opacity: 1,
            transition: {
              duration: .6,
              ease: "easeInOut",
            },
          },
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [clicked, setClicked] = useState(false);
  const openLinkInNewTab = (url) => {
    window.open(url, "_blank");
  };
  useEffect(() => {
    if (clicked) {
      setTimeout(() => {
        setClicked(false);
      }, 2000);
    }
  }, [clicked]);
  const copyToClipboard = () => {
    navigator.clipboard.writeText("agtari957@gmail.com");
    setClicked(true);
  };
  return (
    <motion.div
      className="contact"
      ref={contactAnimation}
      initial="hidden"
      animate={contactAnimationInView ? "visible" : "hidden"}
      variants={animationVariantscontactAnimation}
    >
      <BsFacebook
        size={25}
        color="#07062b"
        onClick={() =>
          openLinkInNewTab(
            "https://www.facebook.com/profile.php?id=100007810788179"
          )
        }
      />
      <BsLinkedin
        size={25}
        color="#07062b"
        onClick={() =>
          openLinkInNewTab("https://www.linkedin.com/in/ala-gtari-869265214/")
        }
      />
      <BsGithub
        size={25}
        color="#07062b"
        onClick={() => openLinkInNewTab("https://github.com/alagtari")}
      />
      <MdEmail
        size={25}
        color="#07062b"
        onClick={() => {
          copyToClipboard();
        }}
      />
      {clicked && <div className="copied">Copied !</div>}
    </motion.div>
  );
}

export default Contact;
